var $583de0b3587601b9$exports = {};
$583de0b3587601b9$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " not selected.");
  },
  "select": "Select",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "No items selected",
      one: function one() {
        return "".concat(formatter.number(args.count), " item selected");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " items selected");
      }
    }), ".");
  },
  "selectedAll": "All items selected.",
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " selected.");
  },
  "longPressToSelect": "Long press to enter selection mode."
};
export { $583de0b3587601b9$exports as default };